import { apolloClient, DOWNLOAD_RESULT_FILE, GET_WORKER_SKILL_CHECKLISTS_QUERY, FETCH_UNA_LINK_MUTATION } from '~/common/apollo'
import { store, observable, action } from '~/common/mobx.decorator'
import { CollectionCursorStore } from '~/stores/collection.cursor.store'

@store()
class ChecklistsStore extends CollectionCursorStore {
	@observable resultFile = {}
	@observable unaLink = ''

	constructor() {
		super(GET_WORKER_SKILL_CHECKLISTS_QUERY, 'workerSkillChecklists', ['totalCount'])
	}

	@action
	downloadResultFile = async (id) => {
		const { data } = await apolloClient.query({
			query: DOWNLOAD_RESULT_FILE,
			variables: {
				id,
			},
		})
		return data?.workerSkillChecklist?.resultFile?.file
	}

	@action
	getUnaLink = async () => {
		const { data } = await apolloClient.mutate({
			mutation: FETCH_UNA_LINK_MUTATION,
		})

		this.unaLink = data?.fetchSclAssignmentLink?.assignmentLink || ''
	}

	@action
	refetchChecklists = async () => {
		this.reset()
		await this.load(true)
	}
}

export const checklistsStore = new ChecklistsStore()
